import React, { Fragment } from 'react';
import { CSSTransitionGroup } from 'react-transition-group';

import NewNavButtonGroup from './NewNavButtonGroup';

const NewCoursePage = ({ children, videoLink, header, ...rest }) => (
  <Fragment>
    {/* <div className="course-page_container"> */}
    <div className="new-course__body--padding">
      <div className="new-course__body__desk">
        <div className="new-course__body__desk--mid">
          <div className="new-course__body__avt">AVT: 0{rest.page}</div>
          <div className="new-course__body__header">{header}</div>
          <div className="new-course__body__video">
            <iframe
              width="100%"
              height="100%"
              src={`https://www.youtube.com/embed/${videoLink}?rel=0`}
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
              title="autzu"
            />
          </div>
        </div>
        <div className="new-course__body__desk--right">
          <div className="new-course__body__content">{children}</div>
        </div>
      </div>
      {/* <NewNavButtonGroup {...rest} /> */}
    </div>
    {/* <span>new button group</span> */}
    <div className="new-course__body__footer--desktop">
      <NewNavButtonGroup {...rest} />
    </div>
  </Fragment>
);

export default NewCoursePage;



// WEBPACK FOOTER //
// ./src/components/NewCourse/NewCoursePage.js